<template>
  <section>
    <div class="item">
      <div class="header">
        <span class="header_title">Commission</span>
        <v-button
          gray
          @click="handleAddFile(1)">Add Rate</v-button>
      </div>

      <div class="table_group">
        <div class="fileTable table_item">
          <div class="tr bold">
            <div class="td name file_name">Current & Future Rates</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="commission.future_data.length == 0 && commission.current_data == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(f_item, f_i) in commission.future_data"
              :key="'f'+f_i"
              class="tr">
              <div class="td name">
                <div class="pct">{{f_item.pct_rate}}%</div>
                <span
                  v-if="f_item.stts_language"
                  class="icon green">{{f_item.stts_language}}</span>
              </div>
              <div class="td center">{{f_item.cmnt_date}}</div>
              <div class="td operation">
                <span
                  class="pointer"
                  @click="handleStartNow(f_item)">Start Today
                </span>
                <span
                  class="pointer"
                  @click="handleEdit(f_item)">Edit</span>
                <span
                  class="del pointer"
                  @click="handleDel(f_item)">Delete</span>
              </div>
            </div>
            <div
              v-for="(c_item, c_i) in commission.current_data"
              :key="'c'+c_i"
              class="tr blue_bg">
              <div class="td name">
                <div class="pct">{{c_item.pct_rate}}%</div>
                <span
                  v-if="c_item.stts_language"
                  class="icon gray">{{c_item.stts_language}}</span>
              </div>
              <div class="td center">{{c_item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
        <div class="oldFileTable table_item">
          <div class="tr bold">
            <div class="td name">Old Rates</div>
            <div class="td center">Start Date</div>
            <div class="td operation"></div>
          </div>
          <template v-if="commission.old_data.length == 0">
            <div class="empty tr">No Data</div>
          </template>
          <template v-else>
            <div
              v-for="(item, i) in commission.old_data"
              :key="i"
              class="tr">
              <div class="td name">
                <div class="pct">{{item.pct_rate}}%</div>
                <span
                  v-if="item.stts_language"
                  class="icon green">{{item.stts_language}}</span>
              </div>
              <div class="td center">{{item.cmnt_date}}</div>
              <div class="td operation"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    
    <insurer-rate-detail
      ref="rate-detail"
      :form="rowData"
      @edit="saveEdit"
      @save="handleSave"></insurer-rate-detail>
  </section>
</template>

<script>
import {addRate, getInsurerPlanDetail, editRate, delRate} from '@/api/account'
import InsurerRateDetail from './popup/insurer-rate-detail.vue'

export default {
  name: 'InsurerPlanDocument',
  components:{
    InsurerRateDetail
  },
  data () {
    return {
      type: 1,
      commission:{
        current_data: [],
        future_data: [],
        old_data: []
      },
      rowData:{}
    }
  },
  computed:{
    options(){
      return this.$route.query || null
    }
  },
  watch:{
    options:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          this.network().getInsurerPlanDetail()
        }
      }
    }
  },
  methods: {
    handleAddFile(type){
      this.type = type
      this.rowData = {}
      this.$refs['rate-detail'].changeDialog()
    },
    handleSave(params){
      this.network().addRate(params)
    },
    updateDetail(){
      this.network().getInsurerPlanDetail()
    },
    handleStartNow(row){
      let params = {
        id: row.id
      }
      this.network().editRate(params)
    },
    handleEdit(row){
      this.$set(this, 'rowData', row)
      this.$refs['rate-detail'].changeDialog()
    },
    handleDel(row){
      let params = {
        id: row.id
      }
      this.network().delRate(params)
    },
    saveEdit(params){
      this.network().editRate(params)
    },
    network(){
      return {
        addRate: async (params) => {
          const {data} = await addRate({
            ...params,
            ...this.options
          })
          if(data.code === 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$refs['rate-detail'].changeDialog()
            this.updateDetail()
          }
        },

        getInsurerPlanDetail: async () => {
          const {data} = await getInsurerPlanDetail({
            ...this.options
          })
          this.commission = data.commission
        },

        editRate: async (params) => {
          const {data} = await editRate(params)
          if(data.code == 1000){
            if(params.cmnt_dt){
              this.$refs['rate-detail'].changeDialog()
            }
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.updateDetail()
          }
        },

        delRate: async (params) => {
          const {data} = await delRate(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.updateDetail()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.item{
  margin-top: 24px;
  .header{
    display: flex;
    justify-content: space-between;
    .header_title{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .table_group{
    margin-top: 20px;
    .table_item{
      .tr{
        background: #FFFFFF;
        border: 1px solid #D1D5DA;
        min-height: 40px;
        display: flex;
        padding: 10px 15px;
        .td{
          flex: 1;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          min-height: 20px;
          color: #24292E;
          &.name{
            min-width: 280px;
            max-width: 400px;
            word-break: break-word;
            .pct{
              font-weight: 600;
              font-size: 14px;
            }
          }
          &.center{
            flex: 2;
            min-width: 200px;
            justify-content: center;
          }
          &.operation{
            min-width: 200px;
            justify-content: flex-end;
            color: #0366D6;
            .del{
              color: #CB2431;
            }
            span+span{
              margin-left: 15px;
            }
          }
          .file_name{
            font-weight: 600;
            color: #0366D6;
          }
          .icon{
            border-radius: 100px;
            height: 20px;
            padding: 1px 8px;
            margin-left: 15px;
            font-weight: 600;
            text-align: center;
            min-width: 70px;
            &.green{
              border: 1px solid #28A745;
              color: #22863A;
            }
            &.gray{
              border: 1px solid #6A737D;
              color: #24292E;
            }
          }
        }
        &.bold{
          background: #F6F8FA;
          .td{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
        &.empty{
          justify-content: center;
          color: #909399;
          font-size: 14px;
        }
        &.blue_bg{
          background: #F1F8FF;
        }
        &:first-child{
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        &:last-child{
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        &+.tr{
          border-top: 0;
        }
      }
    }
    .oldFileTable{
      margin-top: 30px;
    }
  }
}
</style>
